import { NgModule } from '@angular/core';
import { CustomerSegmentsComponent } from './customer-segments.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { RouterModule } from '@angular/router';
import { FilePondModule } from 'ngx-filepond';
import { SharedModule } from '../../shared/shared.module';
import { CustomerSegmentListComponent } from './customer-segment-list/customer-segment-list.component';
import { CustomerSegmentEditComponent } from './customer-segment-edit/customer-segment-edit.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    BrowserModule,
    FilePondModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    SharedModule,
    TranslateModule
  ],
  declarations: [CustomerSegmentsComponent, CustomerSegmentEditComponent, CustomerSegmentListComponent],
  providers: []
})
export class CustomerSegmentsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/customer-segments/customer-segments.module.ts